export const PATIENTS_PER_PAGE = 50
export const COUNT_LIMIT = 1000
